import Select from "react-select";

const SimpleSelect = ({
    options,
    value,
    onInputChange,
    isLoading = false,
    noOptionsMessage = () => "No options available",
    placeholder = "Select location",
    onChange,
    selectedOption,
    clearable,
    searchable,
    dashed = false,
    defaultValue = null,
}) => {
    return (
        <Select
            options={options}
            isClearable={clearable}
            styles={ dashed ? dashedStyle : customStyles }
            isSearchable={searchable}
            formatOptionLabel={formatOptionLabel}
            inputValue={value}
            onInputChange={onInputChange}
            isLoading={isLoading}
            filterOption={null}
            defaultValue={defaultValue}
            value={selectedOption}
            noOptionsMessage={noOptionsMessage}
            placeholder={placeholder}
            onChange={onChange}
        />
    );
};

export default SimpleSelect;

const customStyles = {
    container: (styles) => ({
        ...styles,
    }),
    control: (base, { isFocused }) => ({
        ...base,
        fontSize: ".8rem",
        fontWeight: 500,
        padding: "",
        outline: isFocused ? "none" : "none",
        boxShadow: isFocused ? "none" : "none",
        transition: "all 0.3s ease-in-out",
        backgroundColor: "transparent",
        border:"1px solid var(--border-color) !important",
        cursor: "pointer",
    }),

    option: (styles, { isHovered, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused
                ? "#f8f9fa"
                : isHovered
                ? "red"
                : "white",
            cursor: "pointer",
            color: "var(--bs-gray-500)",
            fontSize: "1rem",
            fontWeight: 400,
        };
    },
    menu: (styles) => ({
        ...styles,
        fontSize: "1rem",
        fontWeight: 400,
        borderRadius: "0.5rem",
        paddingBlock: "5px",
        border: "1px solid rgba(var(--bs-primary-rgb), 0.7) !important",
        scrollbarWidth: "4px",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        transition: "all 0.3s ease-in-out",
        boxSizing: "border-box",
        position: "absolute",
        zIndex: "999999999",
    }),
    loadingIndicator: (styles) => ({
        ...styles,
        display: "none",
    }),
    input: (styles) => ({
        ...styles,
        border: "none !important",
        width: "100%",
        backgroundColor: "transparent",
        cursor: "pointer",
    }),

    placeholder: (styles) => ({
        ...styles,
        backgroundColor: "transparent",
        padding: "6px 0px",
    }),

    indicatorSeparator: (base) => ({
        ...base,
        width: "0 !important",
    }),
    clearIndicator: (base) => ({
        ...base,
        // display: "none",
    }),
    valueContainer: (base) => ({
        ...base,
        paddingInlineEnd: "1.5rem",
        border: "none",
        backgroundColor: "transparent",
    }),

    singleValue: (styles) => ({
        ...styles,
        width: "100%",
        background: "transparent",
        border: "none !important",
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        display: "none",
    }),
};

const dashedStyle = {
    ...customStyles,
    control: (base, { isFocused }) => ({
        ...base,
        fontSize: ".9rem",
        fontWeight: 500,
        paddingBlock: "5px",
        outline: isFocused ? "none" : "none",
        boxShadow: isFocused ? "none" : "none",
        transition: "all 0.3s ease-in-out",
        backgroundColor: "transparent",
        border: "2px dashed var(--border-color) !important",
        cursor: "pointer",
    })
};

const formatOptionLabel = (option) => (
    <div
        style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
        }}
    >
        <div
            style={{
                flexGrow: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
            }}
        >
            {option.label}
        </div>
    </div>
);
